import { computed, ref } from 'vue';

import type { MessageInfoSchemaType } from '@/entities/message';
import type { SendMessageInput } from '@/shared/api';

const useMessageEditContentState = () => {
  const initialMessage = ref<MessageInfoSchemaType | null>(null);
  const messageText = ref<SendMessageInput['content']>('');

  const messageContent = computed<SendMessageInput>(() => ({
    content: messageText.value.trim(),
    type: 'text',
  }));

  const isMessageTextExists = computed<boolean>(() => messageText.value.trim().length !== 0);
  const isMessageContentValid = computed<boolean>(() => isMessageTextExists.value);

  const isMessageContentChanged = computed<boolean>(
    () => messageText.value.trim() !== initialMessage.value?.content,
  );

  const resetMessageContent = () => {
    messageText.value = '';
  };

  const setCurrentContent = (message: MessageInfoSchemaType) => {
    initialMessage.value = message;

    messageText.value = message.content;
  };

  return {
    messageText,
    messageContent,
    isMessageContentValid,
    isMessageContentChanged,
    resetMessageContent,
    setCurrentContent,
  };
};

export { useMessageEditContentState };
